import routeMap from "../router_map";

export default {
  path: "/contact",
  meta: {
    title: "联系人",
    icon: "lollipop",
    rank: 11
  },
  children: [
    {
      path: "/contact/index",
      name: "contactIndex",
      meta: {
        title: "联系人管理"
      }
    },
    {
      path: "/contact/create",
      name: "contactCreate",
      meta: {
        title: "添加联系人"
      }
    },
    ...routeMap["/contact/index"]
  ]
};
